import { Navigate, useLocation, useParams } from 'react-router-dom'

// The four lineup-editor steps now live under /team/{id}/lineups/* (#361). The
// old flat URLs (/team/{id}/defense etc.) 301 to the nested ones at IIS; this
// client-side <Navigate> mirrors that redirect so any in-app link or bookmark
// that hits a cached SPA shell still lands correctly. Kept permanently as a
// belt-and-braces fallback. Preserves the ?vs=rhp|lhp query string.
export function LineupStepRedirect({ step }: { step: string }) {
  const { teamId } = useParams()
  const { search } = useLocation()
  return <Navigate to={`/team/${teamId}/lineups/${step}${search}`} replace />
}
